import { render } from "./ManageUsers.vue?vue&type=template&id=03974458"
import script from "./ManageUsers.vue?vue&type=script&lang=js"
export * from "./ManageUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__